import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { defaultUserRoute } from '../../config/routes.config';
import { isAdminUsersPrivilege, isSAPrivilege } from '../../utils/jwt.utils';

@Injectable()
export class AdminUserGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  canLoad(
    _route: Route
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  private checkAccess() {
    if (isAdminUsersPrivilege() || isSAPrivilege()) {
      return true;
    } else {
      this.router.navigateByUrl(defaultUserRoute);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/guards/admin/admin-user.guard.ts